import { OneShipSocket } from './oneship-socket'

export * from './constants'
export * from './socket'
export * from './oneship-socket'
export default new OneShipSocket()
